function designNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function getTrackingRulesParams(design, stageNumber) {
  const durationSeconds = designNumber(design?.[`stage${stageNumber}DurationSeconds`]);
  const countdownSeconds = designNumber(
    design?.[`stage${stageNumber}CountdownSeconds`] ?? design?.trackingCountdownSeconds
  );
  const dollarsPerSecond = designNumber(design?.trackingDollarsPerSecond);
  const maxPerParticipant = designNumber(design?.[`stage${stageNumber}MaxPerParticipant`]);

  return {
    durationSeconds,
    countdownSeconds,
    dollarsPerSecond,
    centsPerSecond: dollarsPerSecond === null ? null : dollarsPerSecond * 100,
    maxPerParticipant,
    emojiMode: design?.emojiMode === true,
  };
}

export function formatCents(cents) {
  if (!Number.isFinite(Number(cents))) {
    return "0";
  }

  return Number.isInteger(cents) ? cents.toString() : cents.toFixed(1);
}

export function formatDollars(dollars) {
  const number = Number(dollars);
  if (!Number.isFinite(number)) {
    return "0";
  }

  return number.toFixed(2).replace(/\.00$/, "");
}
